import { BookOpen, GraduationCap } from 'lucide-react'
import { sdk } from '@/lib/sdk'
import { isEmptyList } from '../emptyList'
import type { ModuleDefinition } from '../types'
import { courseRow } from '../layouts/rows'
import { lazyPage } from '@/lib/lazyPage'

const CoursesPage = lazyPage(() => import('@/pages/Courses'), 'CoursesPage')
const CourseDetailsPage = lazyPage(() => import('@/pages/CourseDetails'), 'CourseDetailsPage')
const CourseLessonPage = lazyPage(() => import('@/pages/CourseLesson'), 'CourseLessonPage')

export const coursesModule: ModuleDefinition = {
  key: 'courses',
  icon: BookOpen,
  iconName: 'book-open',
  namespaces: ['courses'],
  ready: true,
  /* F-198: the default is what the page always drew. */
  layouts: { fallback: 'cards', renders: ['cards', 'list', 'showcase'], toRow: courseRow },
  ListPage: CoursesPage,
  /* `/{section}/{space}/{course}/lessons/{lessonId}` is a lesson; the course
     page is the same route without the last two segments. */
  renderDetail: ({ params }) => params.lessonId ? <CourseLessonPage /> : <CourseDetailsPage />,
  singleItem: { isEmpty: async (spaceId) => isEmptyList(await sdk.courses.list({ spaceId, limit: 1 })) },
  workflow: { trigger: { block: 'courses', icon: GraduationCap, families: ['course', 'lesson', 'quiz'] } }
}
